// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"3ddd8058","653":"a22663a7","707":"cdd1a3d1"}[chunkId] + ".chunk.js";
};